module.exports = __webpack_public_path__ + "img/daydream-vacations-photo-frame-thumb.jpg";